/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import footerLogo from '../../assets/images/footer-logo.png';

const FooterWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 42px;
	padding: 8px 12px;
	background: #55688b;
	background: -moz-linear-gradient(top, #55688b 0%, #455470 100%);
	background: -webkit-linear-gradient(top, #55688b 0%,#455470 100%);
	background: linear-gradient(to bottom, #55688b 0%,#455470 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#55688b', endColorstr='#455470',GradientType=0 );
`;

const Logo = styled.img`
	height: auto;
`;

const Footer = ({style = {}}) => (
    <FooterWrapper style={style}>
        <Logo src={footerLogo} alt="Teamspirit Logo"/>
    </FooterWrapper>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js